/////////////////////////////////////////////////////////////
//ASINHRONI POZIVI ZA FONT I CSS
/////////////////////////////////////////////////////////////
//WebFontConfig = {
//    google: {
//        families: ['Open Sans:300,400,600,700']
//    }
//};
//
//(function() {
//    var wf = document.createElement('script');
//    wf.src = ('https:' == document.location.protocol ? 'https' : 'http') +
//    '://ajax.googleapis.com/ajax/libs/webfont/1.4.7/webfont.js';
//    wf.type = 'text/javascript';
//    wf.async = 'true';
//    var s = document.getElementsByTagName('script')[0];
//    s.parentNode.insertBefore(wf, s);
//})();
//
//loadCSS("assets/css/style.css");

var ucitaniProizvodi = null;
var slanje = null;

var lastScrollTop = 0;

window.onload = function() {
    //console.log("SPREMAN BAS!");
    ucitaniProizvodi = prikupiUcitanePro();
    slanje = generisiSlanje(ucitaniProizvodi);
    //console.log(slanje);

    sendAnalytics(slanje);

    //POZIVANJE ANALITIKE ZA IMPRESIJU, PROSLEDJUJE SE ARR SLANJE
};

window.addEventListener("scroll", function(){
   var st = window.pageYOffset || document.documentElement.scrollTop;
   if (st > lastScrollTop){
      let noviProizvodi = prikupiUcitanePro();

      //console.log(ucitaniProizvodi);
      //console.log(noviProizvodi);

        if(noviProizvodi && ucitaniProizvodi && noviProizvodi.length > ucitaniProizvodi.length) {
            let razlikaProizvoda = noviProizvodi.filter(function(obj) { return ucitaniProizvodi.indexOf(obj) == -1; });
            //console.log(razlikaProizvoda);

            slanje = generisiSlanje(razlikaProizvoda);
            ucitaniProizvodi = noviProizvodi;
            //console.log(slanje);
            sendAnalytics(slanje);

            //POZIVANJE ANALITIKE ZA IMPRESIJU, PROSLEDJUJE SE ARR SLANJE
        }
   }
   lastScrollTop = st <= 0 ? 0 : st;
}, false);




/////////////////////////////////////////////////////////////
//FIXED HEADER
/////////////////////////////////////////////////////////////
function fixedHeader(){
// Fixed Header
    var headerHeight = $('#header').outerHeight();
    var topOffset = $(window).scrollTop();
    if(topOffset > ( headerHeight + 100 ) ){
        $('body').addClass('fixed-header');
    }
    $(window).on('scroll', function(){
        var fromTop = $(this).scrollTop();
        if(fromTop > ( headerHeight + 100 )){
            $('body').addClass('fixed-header');
        }
        else{
            $('body').removeClass('fixed-header');
        }

    });
}
fixedHeader();


/////////////////////////////////////////////////////////////
//CUSTOM DROPDOWN
/////////////////////////////////////////////////////////////
/*
 HTML STRUCTURE:
 <div class="c-drop-holder" data-drop="holder">
 <a class="c-drop-trigger" data-drop="trigger">Trigger text</a>
 <div class="c-drop-content" data-drop="content">    </div>
 </div>
 */

//custom dropdown
$('body').on('click', '*[data-drop="trigger"]', function () {

    var $dropHolder = $(this).closest('[data-drop="holder"]');

    if ($dropHolder.hasClass('drop-open')) {
        $dropHolder.removeClass('drop-open');
    } else {
        $('[data-drop="holder"]').removeClass('drop-open');
        $dropHolder.addClass('drop-open');
    }
});

//custom dropdown close on click outside
$(document).click(function (e) {
    if (!($(e.target).is('[data-drop="holder"], [data-drop="holder"] *'))) {
        $('[data-drop="holder"]').removeClass('drop-open');
    }
});

/////////////////////////////////////////////////////////////
//CUSTOM CHECKBOXES
/////////////////////////////////////////////////////////////
/*
 HTML STRUCTURE:
 <div class="checkbox" data-checkbox="block">
 <input type="checkbox" id="someID" name="someNAME" value="1" checked="checked">
 <label for="someID" class="active">Some label text</label>
 </div>
 */
$('*[data-checkbox="block"] input').on("change", function () {
    var $that = $('this');
    $(this).siblings("label").toggleClass("active");
});

$('*[data-checkbox="all"]').on("change", function () {
    if($(this).is(':checked')){
        $(this).closest('*[data-checkbox="group-holder"]').find('label').addClass('active').siblings('input').prop('checked', true);
    }else {
        $(this).closest('*[data-checkbox="group-holder"]').find('label').removeClass('active').siblings('input').prop('checked', false);
    }
});

$('*[data-checkbox="uncheckAll"]').on("click", function () {
    $('*[data-checkbox="group-holder"]').find('label').removeClass('active').siblings('input').prop('checked', false);
});

/////////////////////////////////////////////////////////////
//CUSTOM RADIO BUTTONS
/////////////////////////////////////////////////////////////
/*
 HTML STRUCTURE:
 <div class="radio-box" data-radio="block">
 <div>
 <input type="radio" name="some_name" value="some_value_1" id="radio1" checked>
 <label class="active" for="radio1">Radio button name 1</label>
 </div>
 <div>
 <input type="radio" name="some_name" value="some_value_2" id="radio2">
 <label for="radio2">Radio button name 2</label>
 </div>
 </div>
 */
$('*[data-radio="block"] input').on('change', function () {
    $(this).closest('[data-radio="block"]').find("label").removeClass("active");
    $(this).siblings("label").addClass("active");
});

// $('#qr_code').on('change', function () {
//     $('label').removeClass('active');
    
//     $(this).closest('.radio-option-holder').find('label').addClass('active');

//     if ($(this).is(':checked')) {
//         $('[data-remodal-id=modal-qr]').remodal({
//             hashTracking: false
//         }).open();
//     }
// });
// $('#qr_code').on('change', function () {
//     // Uklanjamo klasu 'active' sa svih labela
//     //$('label').removeClass('active');
    
//     // Dodajemo klasu 'active' na label koji je povezan sa selektovanim inputom
//     $(this).closest('.radio-option-holder').find('label').addClass('active');

//     // Prikazujemo pozadinu i modal
//     $('#m-qr-code .modal-bg').fadeIn();  // Pokaži pozadinu
// });

// // Zatvaranje modala kada se klikne na dugme za zatvaranje
// $('.modal-qr-code .close').on('click', function () {
//     $('#m-qr-code .modal-bg').fadeOut();  // Sakrij pozadinu
// });





/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//IMAGE POSITIONING
/////////////////////////////////////////////////////////////
/*
 HTML STRUCTURE:
 <div class="ratiox-x" data-positioning="holder">
 <img data-positioning="img" src="<?php echo base_url('some-image...') ?>" alt=""/>
 </div>
 */

//image positioning
function imagePositioning() {
    $('*[data-positioning="img"]').delay(10).queue(function () {

        var image = $(this),
            imageHolder = $(this).closest('[data-positioning="holder"]');
        image.src = $(this).attr("src");
        var imageHeight = image.get(0).naturalHeight,
            imageWidth = image.get(0).naturalWidth,
            imageHolderHeight = imageHolder.height(),
            imageHolderWidth = imageHolder.width();

        var imgProp = imageHeight / imageWidth,
            imgHolderProp = imageHolderHeight / imageHolderWidth;

        image.addClass('cover-img');
        imageHolder.addClass('image-holder');

        if (imgProp > imgHolderProp) {
            $(this).addClass('align-width');
        } else {
            $(this).addClass('align-height');
        }
    });
};

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//CUSTOM ACCORDION FOR FAQ
/////////////////////////////////////////////////////////////
/*
 HTML STRUCTURE:
 <div data-accordion="block">
 <h3 data-accordion="trigger">Some Text</h3>
 <div data-accordion="content">Some text</div>
 </div>
 */

function customAccordion() {

    //open first element and hide others
    if ($('*[data-accordion="block"]').length) {
        $('[data-accordion="content"]').hide();
        $('*[data-accordion="block"]').first().addClass('active').find('[data-accordion="content"]').show();
    }

    //click events
    $('*[data-accordion="trigger"]').on('click', function () {
        var $this = $(this);
        if (!($(this).closest('[data-accordion="block"]').hasClass('active'))) {
            $('*[data-accordion="block"]').removeClass('active').find('[data-accordion="content"]').slideUp();
            $this.closest('[data-accordion="block"]').addClass('active').find('[data-accordion="content"]').slideDown();
        } else {
            $this.closest('[data-accordion="block"]').removeClass('active').find('[data-accordion="content"]').slideUp();
        }
    });
};
customAccordion();

//FAQ - SCROLL TO QUESTION
$.fn.scrollView = function () {
    return this.each(function () {
        $('html, body').animate({
            scrollTop: $(this).offset().top - 150
        }, 1000);
    });
}
$('*[data-accordion="trigger"]').click(function (event) {
    event.preventDefault();
    $(this).delay(500).queue(function(n) {
        $(this).show().scrollView();
        n();
    });
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//SHOW/HIDE CONTENT (SLIDE)
/////////////////////////////////////////////////////////////
/*
 HTML STRUCTURE:
 <a data-slide-trigger="someNAME"></a>
 <div data-slide-content="someNAME"></div>
 */

//hide all content first
if (($('[data-slide-content]')).length) {
    $('[data-slide-content]').hide();
}

//toggle slide
$('[data-slide-trigger]').on('click', function (e) {
    if ($(e.target).is('a, a *')) {
        e.preventDefault();
    }
    var dataValue = ($(this).data('slide-trigger'));
    $('*[data-slide-content="' + dataValue + '"]').slideToggle();

    //ovaj deo je za filtere na listi proizvoda i kategorije bloga
    if($(this).find('span').hasClass('plus-minus')) {
        $(this).find('span').toggleClass('trigger-active');
    }
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//SHOW/HIDE CONTENT FOR USER TYPE ON REGISTRATION PAGE
/////////////////////////////////////////////////////////////
$('[name="fake_user_type"]').click(function () {
    if ($(this).val() === 'natural_person') {
        // hide legal entity form
        $('#company-data-holder').slideUp();
    }
    else {
        $('#company-data-holder').slideDown();
    }

    if ($("input[name=user_type]").val() != "not_registered") {
        $("input[name=user_type]").val($(this).val());
    }
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//MA MODAL
/////////////////////////////////////////////////////////////
function initScrollbar(){
    $('.scroll-holder').scrollbar({});
};
function destroyScrollbar(){
    $('.scroll-holder').scrollbar('destroy');
}

$('*[data-modal-trigger]').on('click', function(e) {
    e.preventDefault();
    var modalType = 'js-' + $(this).attr('data-modal-trigger') + '-modal';
    $('.js-ma-modal-content').html($('.'+modalType).html());
    $('body').addClass('ma-modal-open');
    initScrollbar();
});

$(document).on('touchstart click', function (e) {
    if ($('body').hasClass('ma-modal-open')) {
        if (!($(e.target).is('[data-modal-trigger], [data-modal-trigger] *, .js-ma-modal-content, .js-ma-modal-content *, .js-ma-modal-trigger, .ui-selectmenu-menu, .ui-selectmenu-menu *'))) {
            //destroyScrollbar();
            $('body').removeClass('ma-modal-open');
        }
    }
});

$('body').on('touchstart click', '.js-close-ma-modal', function (e) {
    e.preventDefault();
    //destroyScrollbar();
    $('body').removeClass('ma-modal-open');

});
/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//NEWSLETTER REMODAL
/////////////////////////////////////////////////////////////
$('[data-remodal-id=newsletter]').remodal({
    hashTracking: false
});
$('[data-remodal-id=modal-r]').remodal({
    hashTracking: false
});
/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
// SIDR (MAIN MENU)
/////////////////////////////////////////////////////////////
$('#responsive-menu-button').on('click', function(e){
    e.preventDefault();
});
$('#responsive-menu-button').sidr({
    name: 'sidr-main',
    source: '#navigation',
    displace: false,
    side: 'left',
    renaming: false
});

$(document).on("click", function (e) {
    if (!($(e.target).is('#sidr-main, #sidr-main *'))) {
        $.sidr('close', 'sidr-main');
    }
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
// SUBMENU TRIGGER
/////////////////////////////////////////////////////////////
$('.submenu-trigger').on('click', function(){
    $(this).siblings('div, ul').slideToggle();
    $(this).toggleClass('open-submenu');
});
/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
// SCROLLBAR
/////////////////////////////////////////////////////////////
$('.scroll-holder').scrollbar({
    ignoreMobile: true
});

$('body').on('click', '.cart-preview', function(){
    $('.scroll-holder').scrollbar({
        ignoreMobile: true
    });
});

$('.checkboxes-scroller').scrollbar({
    ignoreMobile: true
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//PRODUCT COUNTERS
/////////////////////////////////////////////////////////////
$("body").on('click', '.product-counter-trigger', function(e){
    e.preventDefault();
    var handler = $(this);
    var counterStep = parseInt(handler.data("counter-step"), 10);
    var counterType = handler.data("counter-type");
    var counterField = handler.data("counter-field");
    var counterAmount = parseInt($(counterField).val(), 10);
    if(!isNaN(counterAmount)){
        if(counterType == 'add'){
            counterAmount = counterAmount + counterStep;
        }
        else if(counterType == 'minus'){
            counterAmount = counterAmount - counterStep;
        }
        if(counterAmount < 1){
            counterAmount = 1;
        }
        handler.parent().find(counterField).val(counterAmount);
    }
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//SLIDERS
/////////////////////////////////////////////////////////////
$('.recommended-products-slider').slick({
    infinite: true,
    slidesToShow: 6,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<a href="#!" class="c-slider-arr prev-slide" aria-label="Prethodni"><span class="fa fa-caret-left" aria-hidden="true"></span></a>',
    nextArrow: '<a href="#!" class="c-slider-arr next-slide" aria-label="Sledeći"><span class="fa fa-caret-right" aria-hidden="true"></span></a>',
    responsive: [
        {
            breakpoint: 1601,
            settings: {
                slidesToShow: 5
            }
        },
        {
            breakpoint: 1200,
            settings: {
                slidesToShow: 4
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2
            }
        }
        // You can unslick at a given breakpoint now by adding:
        // settings: "unslick"
        // instead of a settings object
    ]
});
// On before slide change
$('.recommended-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    revalidateBLazy();
});
function cleanSlickARIA() {
    $('.slick-dots').removeAttr('role aria-label');
    $('.slick-dots li').removeAttr('role aria-selected aria-controls aria-hidden aria-label');
    $('.slick-dots li button').removeAttr('role aria-selected aria-controls aria-hidden aria-label');

    $('.slick-slide').removeAttr('role aria-selected aria-controls aria-hidden aria-label');
    $('.slick-track').removeAttr('role aria-label');

    setTimeout(function(){
        $('.slick-dots, .slick-dots li, .slick-dots li button, .slick-slide, .slick-track')
            .removeAttr('role aria-selected aria-controls aria-hidden aria-label');
    }, 50);
}

$('.blog-preview-slider').on('init reInit afterChange setPosition', function(){
    cleanSlickARIA();
});

$('.blog-preview-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    dots: true,
    responsive: [
        {
            breakpoint: 992,
            settings: { slidesToShow: 2 }
        },
        {
            breakpoint: 576,
            settings: { slidesToShow: 1 }
        }
    ]
});

setTimeout(cleanSlickARIA, 300);
$('.blog-preview-slider').on('afterChange', function(event, slick, currentSlide, nextSlide){
    revalidateBLazy();
});

$('.related-products-slider').slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    swipeToSlide: true,
    vertical: true,
    verticalSwiping: true,
    prevArrow: '<a href="#!" class="c-slider-arr prev-slide" aria-label="Prethodni"><span class="fa fa-caret-left" aria-hidden="true"></span></a>',
    nextArrow: '<a href="#!" class="c-slider-arr next-slide" aria-label="Sledeći"><span class="fa fa-caret-right" aria-hidden="true"></span></a>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                vertical: false,
                verticalSwiping: false
            }
        }
    ]
});
// On before slide change
$('.related-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    revalidateBLazy();
});

$( document ).ready(function() {
    $('.related-products-news-slider').slick({
        infinite: true,
        slidesToShow: get_article_slider_number(),
        slidesToScroll: 1,
        swipeToSlide: true,
        vertical: true,
        verticalSwiping: true,
        prevArrow: '<a href="#!" class="c-slider-arr prev-slide" aria-label="Prethodni"><span class="fa fa-caret-left" aria-hidden="true"></span></a>',
        nextArrow: '<a href="#!" class="c-slider-arr next-slide" aria-label="Sledeći"><span class="fa fa-caret-right" aria-hidden="true"></span></a>',
        responsive: [
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false
                }
            },
            {
                breakpoint: 576,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1,
                    vertical: false,
                    verticalSwiping: false
                }
            }
        ]
    });
});

function get_article_slider_number(){
    var height = $('.blog-post').height();
    var number = Math.floor(height / 480);

    return number;
}

// On before slide change
$('.related-products-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    revalidateBLazy();
});

$('.related-blog-preview-slider').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    swipeToSlide: true,
    prevArrow: '<a href="#!" class="c-slider-arr prev-slide" aria-label="Prethodni"><span class="fa fa-caret-left" aria-hidden="true"></span></a>',
    nextArrow: '<a href="#!" class="c-slider-arr next-slide" aria-label="Sledeći"><span class="fa fa-caret-right" aria-hidden="true"></span></a>',
    responsive: [
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1
            }
        },
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 1
            }
        }
    ]
});
// On before slide change
$('.related-blog-preview-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    revalidateBLazy();
});


$('.testimonials-slider').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    swipeToSlide: true,
    arrows: false,
    dots: true
});
// On before slide change
$('.related-blog-preview-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide){
    revalidateBLazy();
});



/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//GLASSCASE GALLERY ON PRODUCT PAGE
/////////////////////////////////////////////////////////////
window.addEventListener('load', function () {

    var $glasscase = $('#glasscase');
    if (!$glasscase.length) return;

    // ukloni statičku LCP sliku
    var staticImg = document.querySelector('.product-image-ratio');
    if (staticImg) {
        staticImg.remove();
    }

    // prikaži gallery
    $glasscase.removeAttr('hidden');

    // INIT glasscase
    $glasscase.glassCase({
        zoomPosition: 'inner',
        isSlowZoom: true,
        isDownloadEnabled: false,
        widthDisplay: 600,
        heightDisplay: 600,
        nrThumbsPerRow: 3,
        colorActiveThumb: -1,
        thumbsMargin: 4,
        isHoverShowThumbs: true
    });

});


/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//PRODUCTS TABS ON HOMEPAGE
/////////////////////////////////////////////////////////////
$('#products-tabs').find('li').first().addClass('active');
$('#products-tabs').siblings('.tab-content').find('.tab-pane').first().addClass('active');

$('#products-tabs').on('click', 'a', function (e) {
    e.preventDefault();
    $(this).tab('show');
});

/////////////////////////////////////////////////////////////
//PRODUCT DESCRIPTION TABS ON PRODUCT BAGE
/////////////////////////////////////////////////////////////
$('#product-description-tabs').find('li').first().addClass('active');
$('#product-description-tabs').siblings('.tab-content').find('.tab-pane').first().addClass('active');

$('#product-description-tabs').on('click', 'a', function (e) {
    e.preventDefault();
    $(this).tab('show');
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//VIEW TYPE CHANGE
/////////////////////////////////////////////////////////////
$('.view-type').on('click', 'a', function (e) {
    e.preventDefault();
    if (!($(this).hasClass('active'))) {
        $('.view-type').find('a').toggleClass('active');
        $('.product-category-list').toggleClass('list-view');
        var optionsBlock = $('.product-category-list').find('.options-block')
        $.each(optionsBlock, function () {
            var location = '';
            if ($('.list-view').length) {
                location = $(this).closest('.product-preview-item').find('.text-block');
            } else {
                var location = $(this).closest('.product-preview-item').find('.image-block');
            }
            $(this).appendTo(location);
        });
    }
});

/////////////////////////////////////////////////////////////

/////////////////////////////////////////////////////////////
//PRICE RANGE
/////////////////////////////////////////////////////////////
$("#slider-range").slider({
    range: true,
    min:  parseFloat($("#min-price").val()),
    max:  parseFloat($("#max-price").val()),
    step: 5,
    values: [
        (parseFloat($("#min-price-filters").val()) || parseFloat($("#min-price").val())),
        (parseFloat($("#max-price-filters").val()) || parseFloat($("#max-price").val()))
    ],
    slide: function(event, ui) {
        $("#amount").val(ui.values[ 0 ] + "-" + ui.values[ 1 ]);
    },
    change: function(event, ui) {
        $("#search-form").find("input[name=min_price]").val(ui.values[0]);
        $("#search-form").find("input[name=max_price]").val(ui.values[1]);
        $("#search-form").trigger("submit");
    }
});
$("#amount").val($("#slider-range").slider("values", 0) + " - " + $("#slider-range").slider("values", 1));

/////////////////////////////////////////////////////////////

// BACK TO TOP

$(document).ready(function () {
    /******************************
     BOTTOM SCROLL TOP BUTTON
     ******************************/

        // declare variable
    var scrollTop = $(".scrollTop"),
        scrollTopResp = $("#stop-responsive.scrollTop"),
        scrollTopOrd = $('#stop.scrollTop')

    $(window).scroll(function () {
        // declare variable
        var topPos = $(this).scrollTop();

        // if user scrolls down - show scroll to top button
        if (topPos > 100) {
            $(scrollTopOrd).css("opacity", "1").css("width", "50px");
            $(scrollTopResp).css("opacity", "1").css("width", "30%");
        } else {
            $(scrollTop).css("opacity", "0").css("width", "0").css("overflow", "hidden");
        }

    }); // scroll END

    //Click event to scroll to top
    // click() scroll top EMD

    /*************************************
     LEFT MENU SMOOTH SCROLL ANIMATION
     *************************************/
        // declare variable
    var h1 = $("#h1").position();
    var h2 = $("#h2").position();
    var h3 = $("#h3").position();

    $('.link1').click(function () {
        $('html, body').animate({
            scrollTop: h1.top
        }, 500);
        return false;

    }); // left menu link2 click() scroll END

    $('.link2').click(function () {
        $('html, body').animate({
            scrollTop: h2.top
        }, 500);
        return false;

    }); // left menu link2 click() scroll END

    $('.link3').click(function () {
        $('html, body').animate({
            scrollTop: h3.top
        }, 500);
        return false;

    }); // left menu link3 click() scroll END

}); // ready() END

// Example
var bLazy = new Blazy();

var revalidateBLazy = function(){

    var delay= 400; //0.4 second

    setTimeout(function() {
        bLazy.revalidate();
    }, delay);
};

$(document).on( 'shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
    revalidateBLazy();
});

//Lightbox
lightbox.option({
    'disableScrolling': true,
    'resizeDuration': 200,
    'wrapAround': true
})




imagePositioning();

var resizeTimer;
$(window).on('resize', function (e) {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {

        imagePositioning();
        fixedHeader();

    }, 10);
});

$('.datepicker').datepicker({
    changeMonth: true,
    changeYear: true,
    yearRange: "1900:2017"
});

/* Category Left Menu - Has Child */
$('.category-menu ul li ul li:has(ul)').addClass('has_sub');

/* Add span in <a> tag if has child */
$( ".has_sub" ).append( "<span></span>" );

$('.has_sub').click(function() {
    $(this).toggleClass("active");
});

/*responsive icon click*/
$( ".cat_re" ).click(function() {
    $( ".category-menu > ul" ).toggle( "slow", function() {
        // Animation complete.
        $('.cat_re').toggleClass("active");
    });
});


/*responsive icon click*/
$( ".block-title" ).click(function() {
    $( ".filter-options" ).toggle( "slow", function() {
        // Animation complete.
        $('.block-title').toggleClass("active");
    });
});

function prikupiUcitanePro() {
    let all = $(".b-loaded").map(function() {
            return $(this).data("id");
    }).get();

    return all;
}

function generisiSlanje(arr) {
    let all = $(".b-loaded").map(function() {
            //provera da vec nije u nizu
            if(!(arr.includes($(this).data("id")))) return;
            let noObj = {
                id: String($(this).data("id")),
                name: $(this).attr("alt"),
                price: $(this).data("price"),
                brand: $(this).data("brand"),
                category: $(this).data("category")

            }
            return noObj;
    }).get();

    return all;
}

function sendAnalytics(products) {
    //console.log(products);
    window.dataLayer.push({
        'event': 'productImp',
        'ecommerce': {
          'currencyCode': 'RSD',
          'impressions': products
        }
    });
}

/////////////////////////////////////////////////////////////

//STAR RATINGS
const stars = document.querySelectorAll(".stars-rate");

stars.forEach((star) => {
  const starIcons = star.querySelectorAll("i");
  const starInputs = star.querySelectorAll(".stars-input");

  starIcons.forEach((starIcon, index1) => {
    starIcon.addEventListener("click", () => {
      starIcons.forEach((siblingStarIcon, index2) => {
        if (index1 >= index2) {
          siblingStarIcon.classList.add("fa-star");
          siblingStarIcon.classList.remove("fa-star-o");
        } else {
          siblingStarIcon.classList.remove("fa-star");
          siblingStarIcon.classList.add("fa-star-o");
        }
      });

      starInputs[index1].checked = true;
    });
  });
});

$(function(){
  $(".form-review").validate();
  
  $(".submit-review").click(function(e){
    var id = $(this).data('id');
    $("#review-"+id).submit();
    
    if(!$("#review-"+id).valid())
    {
      e.preventDefault();
    } else {
      console.log('Submit...');
    }
  });
});

//RATE PRODUCTS ACCORDION
function productAccordion() {
  $(".product-accordion").on("click", function () {
    const accordionContent = $(this)
      .parent()
      .nextAll(".product-review")
      .first();
    const accordionArrow = $(this).find(".product-accordion-arrow");
    if (accordionContent.hasClass("product-accordion-active-js")) {
      accordionContent.removeClass("product-accordion-active-js");
      accordionContent.slideUp();
      accordionArrow.removeClass("product-accordion-arrow-active");
    } else {
      accordionContent.addClass("product-accordion-active-js");
      accordionContent.slideDown();
      accordionArrow.addClass("product-accordion-arrow-active");
    }
  });
}

productAccordion();

